import React from 'react';
import { useDroppableHeaderContext } from '../droppableHeaderV2.hook';
import EditGlyph from '../../../../assets/icons/Glyph/EditGlyph';
import EyeGlyph from '../../../../assets/icons/Glyph/EyeGlyph';

type OptionsDetailsOrEditButtonProps = {
  isEdit?: boolean;
  onClick: () => void;
};

export function DroppableHeaderOptionsDetailsOrEditButton({ isEdit, onClick }: OptionsDetailsOrEditButtonProps) {
  const { glyphColor, textColor, handleClickEvent } = useDroppableHeaderContext();

  return (
    <button type='button' className={`${textColor} unstyled-button mr-5 edit-option`} onClick={e => handleClickEvent(e, onClick)}>
      <span className='icon-container'>{isEdit ? <EditGlyph color={glyphColor} /> : <EyeGlyph color={glyphColor} />}</span>
      <span className={textColor}>{isEdit ? 'Edit' : 'Details'}</span>
    </button>
  );
}
